/* ==========================================================================
   Behind The Scenes gallery — the visitor starts each reel.

   Nothing plays on its own. The clips ship with preload="none" and no autoplay
   attribute, so the page shows each poster frame and downloads nothing until
   someone presses play. Four autoplaying reels used to pull roughly 44 MB on
   load, and an earlier version of this file started them on scroll, which is
   still autostarting.

   Behaviour:
     - click a tile (or its play button) to start; click again to pause
     - starting one reel pauses any other that is running
     - scrolling a playing reel out of view pauses it
     - hiding the tab pauses everything
   ========================================================================== */
(function () {
  'use strict';

  function boot() {
    var vids = Array.prototype.slice.call(
      document.querySelectorAll('video.js-gallery-video')
    );
    if (!vids.length) return;

    function tileOf(v) {
      return v.closest ? v.closest('.gallery-grid-item') : v.parentNode;
    }

    function markPlaying(v, playing) {
      var tile = tileOf(v);
      if (tile) tile.classList.toggle('is-playing', playing);
    }

    function pauseOthers(except) {
      vids.forEach(function (v) {
        if (v !== except && !v.paused) {
          v.pause();
          markPlaying(v, false);
        }
      });
    }

    function toggle(v) {
      if (v.paused) {
        pauseOthers(v);
        // Only fetch the file once someone actually asks for it.
        if (v.preload !== 'auto') v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) {
          p.catch(function () { markPlaying(v, false); });
        }
        markPlaying(v, true);
      } else {
        v.pause();
        markPlaying(v, false);
      }
    }

    vids.forEach(function (v) {
      var tile = tileOf(v);
      var btn = tile && tile.querySelector('.js-gallery-play');

      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggle(v);
        });
      }
      // The whole tile is clickable too, which is what people try first.
      if (tile) {
        tile.addEventListener('click', function () { toggle(v); });
        tile.style.cursor = 'pointer';
      }
      // Keep the class in step if playback ends or stalls for any other reason.
      v.addEventListener('pause', function () { markPlaying(v, false); });
      v.addEventListener('play', function () { markPlaying(v, true); });
    });

    // A reel scrolled off screen should stop rather than keep decoding. This only
    // ever pauses — it never starts anything.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && !entry.target.paused) {
            entry.target.pause();
            markPlaying(entry.target, false);
          }
        });
      }, { threshold: 0 });
      vids.forEach(function (v) { io.observe(v); });
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      vids.forEach(function (v) {
        if (!v.paused) { v.pause(); markPlaying(v, false); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
